import { render, staticRenderFns } from "./industryCard.vue?vue&type=template&id=5115e280&scoped=true&"
import script from "./industryCard.vue?vue&type=script&lang=js&"
export * from "./industryCard.vue?vue&type=script&lang=js&"
import style0 from "./industryCard.vue?vue&type=style&index=0&id=5115e280&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5115e280",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5115e280')) {
      api.createRecord('5115e280', component.options)
    } else {
      api.reload('5115e280', component.options)
    }
    module.hot.accept("./industryCard.vue?vue&type=template&id=5115e280&scoped=true&", function () {
      api.rerender('5115e280', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/profile/crudApp/industryCard.vue"
export default component.exports